const initEconomicCalendar = () => {
  const applyCheckbox = (checkbox) => (checkbox.checked = true);
  const unapplyCheckbox = (checkbox) => (checkbox.checked = false);

  const filterCard = document.querySelector('[data-filter-card]');
  const toggleFilterCard = document.querySelector('[data-toggle-filter-card]');

  toggleFilterCard.addEventListener('click', (e) => {
    toggleFilterCard.classList.toggle('c_button--pale_bordered');
    filterCard.classList.toggle('hidden');
  });

  const filterSections = document.querySelectorAll('[data-filter-section]');
  filterSections.forEach((section) => {
    const applyAllCheckboxes = section.querySelector('[data-apply-all-checkboxes]');
    const unapplyAllCheckboxes = section.querySelector('[data-unapply-all-checkboxes]');
    const checkboxes = section.querySelectorAll("input[type='checkbox'");

    applyAllCheckboxes.addEventListener('click', (e) => {
      checkboxes.forEach((checkbox) => applyCheckbox(checkbox));
    });

    unapplyAllCheckboxes.addEventListener('click', (e) => {
      checkboxes.forEach((checkbox) => unapplyCheckbox(checkbox));
    });
  });
};

export default initEconomicCalendar;
